function toHandle(t) {
    return t.toLowerCase().replace(/[()]/g, "").replace(/[\W]/g, "-")
}
function load_icons() {
    var t = Object.keys(feather.icons);
    Array.prototype.forEach.call(document.querySelectorAll("[data-feather]"), function(e) {
        var a = e.dataset.feather;
        t.indexOf(a) < 0 && (console.warn('No such icon "' + a + '" in feather, element', e),
        e.dataset.featherInvalid = a,
        delete e.dataset.feather)
    });
    try {
        feather.replace()
    } catch (t) {
        console.error("Unable to load icons:", t)
    }
}
var testimonials = {};
function formatMoney(t, e) {
    var a = theme.moneyFormat;
    "string" == typeof t && (t = t.replace(".", ""));
    var o = ""
      , i = /\{\{\s*(\w+)\s*\}\}/
      , n = e || a;
    function r(t, e, a, o) {
        if (null == e && (e = 2),
        a = a || ",",
        o = o || ".",
        isNaN(t) || null == t)
            return 0;
        var i = (t = (t / 100).toFixed(e)).split(".");
        return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (i[1] ? o + i[1] : "")
    }
    switch (n.match(i)[1]) {
    case "amount":
        o = r(t, 2);
        break;
    case "amount_no_decimals":
        o = r(t, 0);
        break;
    case "amount_with_comma_separator":
        o = r(t, 2, ".", ",");
        break;
    case "amount_no_decimals_with_comma_separator":
        o = r(t, 0, ".", ",");
        break;
    case "amount_no_decimals_with_space_separator":
        o = r(t, 0, " ")
    }
    return '<span class="money">' + n.replace(i, o) + "</span>"
}
function Product(t) {
    if (this.config = {
        shopify_ajax_add_url: "/cart/add.js",
        shopify_ajax_url: "/cart.js"
    },
    this.element = t,
    this.$element = $(t),
    this.sectionId = this.element.dataset.sectionId,
    document.querySelector("#ProductJson-" + this.sectionId)) {
        this.product = JSON.parse(document.querySelector("#ProductJson-" + this.sectionId).innerText),
        this.$selects = this.$element.find(".selector-wrapper select, .materialize-select select"),
        this.$selects.on("change", this.on_select_change.bind(this)),
        this.$original_select = this.$element.find(".original-select"),
        this.$old_price = this.$element.find(".compare-at-price .money"),
        this.$price = this.$element.find("#price-field"),
        this.$cart = this.$element.find("#purchase"),
        this.$spb = this.$element.find(".shopify-payment-button"),
        this.$sale = this.$element.find(".sale-badge,.compare-at-price"),
        this.$sale_price = this.$element.find(".compare-at-price"),
        this.$variant_percentage_wrapper = this.$element.find(".variant-percentage-wrapper"),
        this.$variant_value_wrapper = this.$element.find(".variant-value-wrapper"),
        this.$variant_value = this.$element.find(".variant-value"),
        this.$featured_image_wrapper = this.$element.find(".featured-image-div"),
        this.$featured_image = this.$element.find(".product-main-image"),
        this.$add_to_cart_form = this.$element.find("#add-to-cart-form"),
        this.$mobile_slider = this.$element.find(".mobile-product-slider"),
        this.$cart_slider_wrapper = $("#cartSlideoutWrapper"),
        this.$thumbnail_wrapper = this.$element.find(".product-thumbnails-wrapper"),
        this.$thumbnails = this.$thumbnail_wrapper.find("a.image-swap"),
        this.$swatch_inputs = this.$element.find("#add-to-cart-form").find(".swatch input"),
        this.$sku = this.$element.find(".indiv-product-sku-text"),
        this.zoom_selector = ".zoomImg",
        this.thumbnail_changes_variant = "true" === this.$element.find("#thumbnail_changes_variant").val(),
        this.added_text_timeout = null,
        this.is_variant_switch_manual = !1,
        this.$swatch_inputs.length > 0 ? this.on_swatch_change() : this.on_select_change(),
        this.$cart.on("click", function(t) {
            t.preventDefault(),
            this.disable_cart_button(),
            this.add_to_cart()
        }
        .bind(this)),
        this.$thumbnails.on("click", function(t) {
            return this.on_thumbnail_click(t.currentTarget),
            !1
        }
        .bind(this)),
        this.$swatch_inputs.on("change", this.on_swatch_change.bind(this));
        var e = this.$mobile_slider.data("flexslider");
        if (e) {
            var a = e.vars.after;
            e.vars.after = function() {
                a(),
                this.is_variant_switch_manual || this.on_mobile_slider_change(),
                this.is_variant_switch_manual = !1
            }
            .bind(this)
        }
    }
}
var CART_LOADING = '<div class="lds-dual-ring"></div><span class="sr-only">Loading...</span>';
function load_product(t) {
    t ? new Product(t.querySelector("#product-box")) : Array.prototype.forEach.call(document.querySelectorAll("#product-box"), function(t) {
        new Product(t)
    })
}
Product.prototype.add_to_cart = function() {
    this.clear_error(),
    $.ajax({
        url: this.config.shopify_ajax_add_url,
        dataType: "json",
        type: "post",
        data: this.$add_to_cart_form.serialize(),
        success: this.added_to_cart.bind(this),
        error: this.add_to_cart_failed.bind(this)
    })
}
,
Product.prototype.disable_cart_button = function() {
    this.added_text_timeout && (clearTimeout(this.added_text_timeout),
    this.added_text_timeout = null),
    this.$cart.addClass("disabled").prop("disabled", !0).html(CART_LOADING)
}
,
Product.prototype.enable_cart_button = function() {
    this.added_text_timeout && (clearTimeout(this.added_text_timeout),
    this.added_text_timeout = null),
    this.$cart.removeClass("disabled").prop("disabled", !1).html(window.theme.strings.addToCart)
}
,
Product.prototype.added_to_cart = function(t) {
    this.update_cart()
}
,
Product.prototype.open_cart_page = function() {
    window.location = "/cart"
}
,
Product.prototype.show_cart = function() {
    this.$cart_slider_wrapper.trigger("cart:open")
}
,
Product.prototype.update_cart = function() {
    $.getJSON(this.config.shopify_ajax_url).then(this.updated_cart.bind(this)).fail(this.update_cart_failed.bind(this))
}
,
Product.prototype.updated_cart = function(t) {
    update_cart_drawer(t),
    this.enable_cart_button();
    var e = this.$cart.data("cart-action");
    "cart" === e ? this.open_cart_page() : "added" === e ? (this.$cart.html(window.theme.strings.added),
    this.added_text_timeout && (clearTimeout(this.added_text_timeout),
    this.added_text_timeout = null),
    this.added_text_timeout = setTimeout(function() {
        this.$cart.html(window.theme.strings.addToCart)
    }
    .bind(this), 2e3)) : this.show_cart()
}
,
Product.prototype.update_cart_failed = function(t) {
    this.enable_cart_button(),
    console.error("Updating the cart failed: ", t)
}
,
Product.prototype.add_to_cart_failed = function(t) {
    this.enable_cart_button();
    var e = "Unknown error";
    0 == t.status || (t.responseJSON ? e = t.responseJSON.description ? t.responseJSON.description : t.responseJSON.message : t.responseText && (e = t.responseText)),
    this.show_error(e)
}
,
Product.prototype.show_error = function(t) {
    $('<div id="cart-error"></div>').addClass("alert alert-danger").text(t).insertAfter(this.$cart)
}
,
Product.prototype.clear_error = function() {
    $("#cart-error").remove()
}
;
var FADE_OUT_ANIMATION_DURATION = 800;
function update_cart_drawer(t) {
    $(".cart-error-box").text(""),
    0 === t.items.length ? ($(".cart-empty-box,.ajax-cart--total-price").removeClass("hide"),
    $(".ajax-cart--total-price,.cart-button-checkout").addClass("hide")) : ($(".cart-empty-box").addClass("hide"),
    $(".ajax-cart--total-price,.cart-button-checkout").removeClass("hide"));
    var e = $("#cart-item-template").html()
      , a = $(".cart-items");
    a.empty(),
    t.items.forEach(function(t, o) {
        var i = $(e);
        t.image ? i.find(".cart-item-image").attr({
            src: t.image,
            alt: t.product_title
        }) : i.find(".cart-item-image").css("display", "none"),
        i.find(".cart-item-link").attr({
            href: t.url
        }),
        i.find(".cart-item-product-title").text(t.product_title),
        i.find(".cart-item-variant-title").text(t.variant_title),
        i.find(".cart-item-price").html(formatMoney(t.final_line_price));
        var n = i.find(".cart-item-price-original");
        t.original_line_price > t.final_line_price ? n.html(formatMoney(t.original_line_price)).show() : n.hide();
        var r = i.find(".cart-item-quantity")
          , s = r.closest(".cart-item--quantity-wrapper")
          , c = function(t) {
            s.addClass("cart-item-quantity-active");
            var e = t <= 0;
            cart_set_quantity(e ? FADE_OUT_ANIMATION_DURATION : 0).always(function() {
                s.removeClass("cart-item-quantity-active"),
                e && (i.addClass("fadeOut animated fast"),
                setTimeout(function() {
                    i.remove()
                }, FADE_OUT_ANIMATION_DURATION))
            })
        };
        r.on("change", function() {
            var t = parseInt($(this).val(), 10);
            c(t)
        }),
        r.val(t.quantity),
        r.attr("name", "updates[" + t.variant_id + "]"),
        i.find(".cart-item-quantity-button").on("click", function() {
            var t = parseInt(r.val(), 10) + parseInt(this.dataset.amount, 10);
            r.val(t),
            c(t)
        });
        var d = i.find(".order-discount--cart-list").empty();
        t.line_level_discount_allocations.forEach(function(t) {
            var e = $('<li class="order-discount--item"></li>');
            $('<span class="order-discount--item"></span>').text(t.discount_application.title).appendTo(e),
            $('<span class="order-discount--cart-title"></span>').html("-" + formatMoney(t.amount)).appendTo(e),
            d.append(e)
        }),
        i.appendTo(a)
    }),
    $(".cart-item-count, .cart-item-count-header--quantity").text(t.item_count),
    $(".cart-item-total-price, .cart-item-count-header--total").html(formatMoney(t.total_price));
    var o = $(".cart-item-original-total-price");
    t.original_total_price > t.total_price ? o.html(formatMoney(t.original_total_price)).show() : o.hide();
    var i = $(".ajax-cart-discount-wrapper").empty();
    t.cart_level_discount_applications.forEach(function(t) {
        var e = $('<div class="cart--order-discount-wrapper--indiv"></div>');
        $('<span class="order-discount"></span>').html("-" + formatMoney(t.total_allocated_amount)).appendTo(e),
        $('<span class="order-discount--cart-title"></span>').text(t.title).appendTo(e),
        i.append(e)
    }),
    window.Currency && Currency.shopCurrency && Currency.convertAll(Currency.shopCurrency, $("[name=currencies]").val())
}
function cart_set_quantity(t) {
    var e = $.Deferred();
    return $(".cart-error-box").text(""),
    $.ajax({
        type: "POST",
        url: "/cart/update.js",
        dataType: "json",
        data: $(".cart-drawer-form").serialize()
    }).then(function(a) {
        e.resolve(),
        setTimeout(function() {
            update_cart_drawer(a)
        }, t)
    }).fail(function(t, a, o) {
        e.reject(),
        console.error("Cart error", a, t, o),
        $(".cart-error-box").empty().text("Unable to update item quantity")
    }),
    e
}
function load_cart_drawer(t) {
    var e = document.querySelector("#initial-cart");
    e && (update_cart_drawer(JSON.parse(e.textContent)),
    $(".cart-button-checkout").on("click", function(t) {
        var e = $(this);
        e.find(".cart-button-checkout-text").addClass("hide"),
        e.find(".cart-button-checkout-spinner").removeClass("hide")
    }))
}
function Parallax(t) {
    this.target = t,
    this.$target = $(t),
    this.img = t.querySelector(".img"),
    this.active = !1,
    this.$target.children(".img").one("load", function() {
        this.init(),
        this.img.style.display = "block"
    }
    .bind(this)).each(function() {
        !this.complete && this.src || $(this).trigger("load")
    }),
    window.addEventListener("scroll", this.update.bind(this), {
        capture: !0,
        passive: !0
    }),
    window.addEventListener("resize", this.init.bind(this))
}
function load_parallax() {
    $(".parallax").each(function() {
        new Parallax(this)
    })
}
function load_search() {
    $(document).ready(function() {
        $(".search-show").off("click").on("click", function() {
            if ($(this).closest(".sticky-header-wrapper").length > 0) {
                var t = $(".sticky-header-search");
                t.toggleClass("expanded"),
                t.find("#search_text").focus()
            } else
                $("#top-search-wrapper").toggleClass("expanded"),
                $("#top-search-wrapper #search_text").focus();
            return !1
        }),
        $(window).width() < 767 && $(".mobile-menu-close").trigger("click")
    })
}
Parallax.prototype.init = function() {
    this.img_height = $(this.img).height(),
    this.container_height = (this.$target.height() > 0 ? this.$target.height() : this.img_height) || 500,
    this.active = !window.matchMedia("screen and (max-width: 767px)").matches,
    this.update()
}
,
Parallax.prototype.update = function() {
    if (this.active) {
        var t = document.body.scrollTop || document.documentElement.scrollTop
          , e = this.img_height - this.container_height
          , a = this.target.getBoundingClientRect().top + t
          , o = a + this.container_height
          , i = window.innerHeight
          , n = e * ((t + i - a) / (this.container_height + i));
        o > t && a < t + i && (this.img.style.transform = "translate3D(-50%," + n + "px, 0)")
    } else
        this.img.style.transform = ""
}
;
var dropdown_timeout = null;
function dropdown_handle_hover() {
    var t = $(".dropdown-envy-toggle,.dropdown-menu");
    t.off("mouseenter").on("mouseenter", function() {
        var t = $(this)
          , e = t.parent();
        dropdown_timeout && clearTimeout(dropdown_timeout),
        dropdown_timeout = setTimeout(function() {
            t.is(".dropdown-envy-toggle") && $(".dropdown.open,.dropdown-submenu.open").removeClass("open"),
            e.addClass("open"),
            select_menu_direction(t.parent())
        }, 10)
    }),
    t.off("mouseleave").on("mouseleave", function() {
        var t = $(this).parent();
        dropdown_timeout && clearTimeout(dropdown_timeout),
        dropdown_timeout = setTimeout(function() {
            t.removeClass("open")
        }, 50)
    })
}
function dropdown_handle_touch() {
    $(".dropdown-envy-toggle").off("touchend").on("touchend", function(t) {
        var e = $(this).parent();
        e.hasClass("open") || (t.preventDefault(),
        e.find(".dropdown-submenu.open").removeClass("open"),
        e.addClass("open"),
        select_menu_direction(e))
    }),
    $(".dropdown-submenu").off("touchend").on("touchend", function(t) {
        var e = $(this);
        e.hasClass("open") || (t.preventDefault(),
        $(".dropdown-submenu.open").removeClass("open"),
        e.addClass("open"))
    }),
    $("body").on("touchstart", function(t) {
        var e = $(".dropdown.open");
        0 !== e.length && 0 === $(t.target).parents(".dropdown.open").length && e.removeClass("open")
    })
}
function load_dropdown_hover() {
    dropdown_handle_hover(),
    dropdown_handle_touch()
}
function select_menu_direction(t) {
    var e = t.find(".dropdown-menu .dropdown-menu").map(function() {
        var t = $(this)
          , e = t.css({
            display: "block",
            visibility: "hidden"
        }).outerWidth();
        return t.css({
            display: "",
            visibility: ""
        }),
        e
    })
      , a = Math.max.apply(null, e)
      , o = t.find("> .dropdown-menu")
      , i = o.offset().left
      , n = i + o.outerWidth() + a > $("body").width() && i - a > 0;
    o.toggleClass("dropdown-submenu-left", n)
}
function load_collection_tag_filter() {
    var t = $(".coll-filter");
    t.on("change", function() {
        var e = [];
        if (t.each(function() {
            var t = $(this).val();
            t && e.push(t)
        }),
        e.length) {
            var a = e.join("+");
            window.location.href = $("#link-to-tag-generic a").attr("href").replace(/\/tag($|\?)/, "/" + a + "$1")
        } else
            window.location.href = $("#link-to-collection").val()
    }),
    $(".coll-filter").material_select()
}
function load_collection_sort() {
    if (Shopify.queryParams = {},
    location.search.length)
        for (var t, e = 0, a = location.search.substr(1).split("&"); e < a.length; e++)
            (t = a[e].split("=")).length > 1 && (Shopify.queryParams[decodeURIComponent(t[0])] = decodeURIComponent(t[1]));
    var o = $("#collection-sort-by").val();
    $("#sort-by").val(o).on("change", function() {
        Shopify.queryParams.sort_by = $(this).val(),
        location.search = $.param(Shopify.queryParams).replace(/\+/g, "%20")
    }),
    $("#sort-by").material_select()
}
function load_collection_mobile_sidebar() {
    $(".collection-sidebar--section h2").on("click", function() {
        $(this).parent().toggleClass("expanded")
    })
}
function create_script(t, e) {
    var a = document.createElement("script");
    a.id = t,
    a.src = e;
    var o = document.getElementsByTagName("script")[0];
    return o.parentNode.insertBefore(a, o),
    a
}
function load_password_recover() {
    var t = $(".recover-form");
    0 !== t.length && (t.removeClass("no-js"),
    "#recover" !== window.location.hash && t.addClass("hide"),
    $(".show-password-form").on("click", function(e) {
        t.toggleClass("hide")
    }))
}
function show_alert(t) {
    $('<div class="page-alert"></div>').append(t.clone()).appendTo("body")
}
function block_select(t) {
    var e = sliders[t.detail.sectionId];
    if (e) {
        var a = parseInt(t.target.dataset.slideIndex);
        e.show_slide(a)
    }
    var o = testimonials[t.detail.sectionId];
    if (o) {
        a = parseInt(t.target.dataset.slideIndex);
        o.show_slide(a)
    }
    if ($(t.target).parents(".homepage-sections-wrapper").find(".mobile-homepage-text-adverts").length > 0)
        a = Array.prototype.indexOf.call(t.target.parentElement.children, t.target);
    t.target.dataset.megaMenuBlockId && $("[data-mega-menu-block-id=" + t.target.dataset.megaMenuBlockId + "]").closest("li.dropdown").addClass("force-open")
}
function get_section_name(t) {
    var e = null;
    if (t && t.detail) {
        var a = {}
          , o = t.target.dataset;
        for (var i in o)
            !o.hasOwnProperty(i) || 0 !== i.indexOf("themeEditorSection-") && 0 !== i.indexOf("shopifyEditorSection") || (a = JSON.parse(o[i]));
        a.hasOwnProperty("type") && (e = a.type)
    }
    return e
}
function onload(t) {
    load_icons(),
    document.addEventListener("shopify:block:select", block_select);
    var e = get_section_name(t);
    e && "product-template" !== e && "indiv-product" !== e || (load_quantity_controls(),
    load_out_of_stock_email_form(),
    load_product(e && t && t.target),
    load_materialize_select()),
    e && "header" !== e || (load_search(),
    load_dropdown_hover()),
    e && "text-over-image" !== e && "image" !== e || load_parallax(),
    e && "collection-template" !== e || (load_collection_tag_filter(),
    load_collection_sort(),
    load_collection_mobile_sidebar()),
    e && "cart-template" !== e || (load_quantity_controls(),
    load_terms_check()),
    e || load_password_recover(),
    load_cart_drawer()
}
function onunload() {
    document.removeEventListener("shopify:block:select", block_select),
    document.removeEventListener("shopify:block:deselect", block_deselect),
    sliders = {}
}
function load_out_of_stock_email_form() {
    $("#notify-me a").on("click", function() {
        return "0" == $("customer_notify").val() ? $("#sold-out form").submit() : $("#notify-me-wrapper").fadeIn(),
        !1
    }),
    $(document).on("variantUnavailable", function(t) {
        if ($(".product-page--submit-action").data("stock-email-enabled")) {
            var e = $(".product-description-header").text()
              , a = $('#notify-me-wrapper input[name="contact[body]"]')
              , o = "Please notify me when " + e + ", variant: " + t.variant.title + " becomes available.";
            a.val(o),
            $(".variant-out-of-stock").fadeIn(),
            $(".product-page--submit-action").addClass("hidden")
        }
    }),
    $(document).on("variantAvailable", function() {
        $(".product-page--submit-action").data("stock-email-enabled") && ($(".variant-out-of-stock").hide(),
        $(".product-page--submit-action").removeClass("hidden"))
    })
}
function load_materialize_select() {
    $("select.materialize").material_select()
}
function load_quantity_controls() {
    $(".quantity-controls button.qty-plus").off().on("click", function(t) {
        t.preventDefault();
        var e = $(this).closest(".quantity-controls").find("input.quantity-selector");
        e.val(parseInt(e.val()) + 1)
    }),
    $(".quantity-controls button.qty-minus").off().on("click", function(t) {
        t.preventDefault();
        var e = $(this).closest(".quantity-controls").find("input.quantity-selector")
          , a = parseInt(e.val()) - 1 < 1 ? 1 : e.val() - 1;
        e.val(a)
    })
}
function load_terms_check() {
    var t = '[name="checkout"], [name="goto_pp"], [name="goto_gc"]';
    $("body").off("click", t, check_terms).on("click", t, check_terms)
}
function check_terms() {
    var t = $(this)
      , e = t.closest("form")
      , a = e.find("#agree");
    if (0 !== a.length && !a.is(":checked"))
        return alert("You must agree with the terms and conditions of sales to check out."),
        e.find(".cart-button-checkout-text").removeClass("hide"),
        e.find(".cart-button-checkout-spinner").addClass("hide"),
        !1;
    t.submit()
}
document.addEventListener("shopify:section:load", onload),
document.addEventListener("shopify:section:unload", onunload),
document.addEventListener("DOMContentLoaded", onload),
$(document).ready(function() {
    load_materialize_select(),
    load_out_of_stock_email_form(),
    load_quantity_controls()
});
